import { Project } from '../types';

const project: Project = {
  slug: 'cardio-essence-center',
  accessPin: '9175',
  qrTickets: ['K9R4Z6'],
  info: {
    id: 7,
    title: 'Cardio Essence Center',
    category: {
      'en-US': 'Institutional',
      'es-MX': 'Institucional',
    },
    year: 2024,
    location: 'La Paz, Baja California Sur',
    floor: '1 floors',
    building: '150aZA-',
    cover: '/images/Cover7.webp',
    description: {
      'en-US':
        'Cardio Essence Center is a modern cardiology clinic designed to evoke serenity, professionalism, and trust through architecture. The project harmonizes clean contemporary lines with warm, natural materials, creating a calming environment for both patients and practitioners. A sculptural water wall in volcanic stone serves as the visual heart of the space, symbolizing rhythm and life. Framed by a marble portal and topped with wooden pergolas, the courtyard floods with daylight, promoting tranquility and introspection.',
      'es-MX':
        'Cardio Essence Center es una clinica cardiologica contemporanea disenada para transmitir serenidad, profesionalismo y confianza. El proyecto armoniza lineas limpias con materiales naturales y calidos, creando un ambiente calmado para pacientes y personal medico. Un muro de agua escultorico en piedra volcanica funciona como corazon visual del espacio, simbolizando ritmo y vida. Enmarcado por un portal de marmol y pergolas de madera, el patio se llena de luz natural y promueve tranquilidad e introspeccion.',
    },
  },
  assets: {
    images: [
      { file: '7.1', ext: 'webp' },
      { file: '7.2', ext: 'webp' },
      { file: '7.3', ext: 'webp' },
      { file: '7.4', ext: 'webp' },
      { file: '7.5', ext: 'webp' },
      { file: '7.6', ext: 'webp' },
      { file: '7.7', ext: 'webp' },
      { file: '7.8', ext: 'webp' },
    ],
    videos: [],
    panos: [],
  },
};

export default project;
